import type { IconData } from '@stacksjs/iconify-core'

export const mapFoldSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M34 44.146c3.882-.716 7.3-1.865 9.397-2.661c1.93-.732 3.164-2.527 3.27-4.534c.142-2.68.333-7.63.333-14.851c0-6.904-.174-11.732-.313-14.486c-.122-2.416-2.548-3.836-4.69-3.084A71 71 0 0 1 34 6.813zM31 6.94c-3.26-1.208-6.429-2.036-8.86-2.574a70 70 0 0 0-3.316-.652A50 50 0 0 0 18 3.58v37.23c3.177.488 6.316 1.328 8.741 2.079c1.317.408 2.414.786 3.18 1.062a54 54 0 0 1 1.079.401zM5.603 6.515C7.7 5.718 11.118 4.569 15 3.853v37.333a70 70 0 0 0-7.997 2.283c-2.142.752-4.567-.668-4.69-3.084C2.174 37.632 2 32.803 2 25.9c0-7.221.19-12.172.332-14.852c.106-2.007 1.341-3.801 3.27-4.533\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default mapFoldSolid
